import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {AnswerService} from '../../../services/api/answer.service';
import {ANSWER_OPTION_VALIDATORS} from '../../../../constants/validators';
import {AnswerOption} from '../../../data/models/test/answer';

@Component({
  selector: 'app-answer-option-create-form',
  templateUrl: './answer-option-create-form.component.html',
  styleUrls: ['./answer-option-create-form.component.css']
})
export class AnswerOptionCreateFormComponent implements OnInit, AfterViewInit  {

  @Input() testId!: number;
  @Input() questionId!: number;
  @Input() options: AnswerOption[] = [];

  @Output() create = new EventEmitter<AnswerOption>();

  @ViewChild('txtarea') input!: ElementRef;

  answerForm = this.fb.group({
    text: ['', ANSWER_OPTION_VALIDATORS.TEXT],
    blockedOptionIds: [[] as number[]],
  });

  constructor(
    private answerService: AnswerService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
      setTimeout(()=> {
          this.input.nativeElement.focus();
      }, 0);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && event.ctrlKey) {
      event.preventDefault();
      this.submit();
    }
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    this.submit();
  }

  submit(): void {
    if (this.answerForm.valid) {
      const blockedOptionIds = this.normalizeBlockedOptionIds(this.answerForm.controls.blockedOptionIds.value);
      this.answerService.addAnswerOption(this.testId, this.questionId, {
        text: this.answerForm.controls.text.value,
        blockedOptionIds,
      })
        .then(option => {
          if (option) {
            this.answerForm.controls.text.setValue('');
            this.answerForm.controls.blockedOptionIds.setValue([]);
            this.create.emit(option);
          }
        });
    }
  }

  get selectableOptions(): AnswerOption[] {
    return this.options || [];
  }

  private normalizeBlockedOptionIds(value: any): number[] {
    if (!Array.isArray(value)) {
      return [];
    }
    const normalized = value
      .map(id => typeof id === 'number' ? id : Number(id))
      .filter(id => typeof id === 'number' && !Number.isNaN(id));
    return Array.from(new Set(normalized));
  }

}
